import React, {useContext, useState} from "react";
import {ToursContext} from "@/ToursContext";
import {useNavigate, useParams} from "react-router-dom";
import ListItemTemplate from "@/components/ListItemTemplate";

const TourListItem = ({ tourPoint }) => {
    const params = useParams();
    const navigate = useNavigate();

    const { accountTours, setAccountTours, activeTour, setActiveTour } = useContext(ToursContext);

    const showTour = () => {
        console.log("show tour ", tourPoint.tour.id);
        setActiveTour(tourPoint.tour.id);
    }

    return (

        <div onClick={showTour}>
            <ListItemTemplate
                icon={tourPoint.tour?.header_logo?.preview_url}
                image={tourPoint.tour?.main_picture?.preview_url}
                name={tourPoint.tour?.name}
                title={tourPoint.tour?.introduction_title}
                description={tourPoint.tour?.introduction_text}
            />
        </div>
    );
}

export default TourListItem;